import i18n from "@/i18n";

const CaseCategory = {
    1: i18n.t("service.case_cat_1"),
    2: i18n.t("service.case_cat_2"),
    3: i18n.t("service.case_cat_3"),
    4: i18n.t("service.case_cat_4"),
    5: i18n.t("service.case_cat_5"),
    6: i18n.t("service.case_cat_6"),
    7: i18n.t("service.case_cat_7"),
    8: i18n.t("service.case_cat_8"),
    9: i18n.t("service.case_cat_9"),
    10: i18n.t("service.case_cat_10"),
    11: i18n.t("service.case_cat_11"),
    12: i18n.t("service.case_cat_12")
};

const CaseStatus = {
    0: i18n.t("service.awaiting"),
    3: i18n.t("service.assigned"),
    1: i18n.t("service.started"),
    2: i18n.t("service.observing"),
    9: i18n.t("service.done")
};

const CaseSources = {
    ext: "EXT",
    meg: "MEG",
    mes: "MES"
};

const CaseExtraTasks = {
    "": i18n.t("service.extra_task_dontknow"),
    "1": i18n.t("service.yes"),
    "0": i18n.t("service.no")
};

const CaseFinalizedTypes = {
    "1": i18n.t("service.finalized_remote_wo_driving"),
    "2": i18n.t("service.finalized_w_driving")
};

const CaseStatusOrder = [0, 3, 1, 2, 9];

export {
    CaseCategory,
    CaseStatus,
    CaseStatusOrder,
    CaseSources,
    CaseExtraTasks,
    CaseFinalizedTypes
};
